import React__default from 'react';
import classnames from 'classnames';

const Subhead = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    type = 'p',
    variant,
    modifier,
    className,
    ...rest
  } = _ref;
  let testId = `subhead-${type}`;
  const classNames = classnames(className, `b-subhead b-${variant}`, {
    [`font-${modifier}`]: Boolean(modifier)
  });
  testId += variant ? `-${variant}` : '';
  return /*#__PURE__*/React__default.createElement(type, {
    ref,
    'data-testid': testId,
    className: classNames,
    ...rest
  }, children);
});
Subhead.displayName = 'Subhead';

export { Subhead };
